import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';
import { requestConfirmBuyPasses } from 'network/services/payments.service';
import { conektaPaymentActionSelector } from 'features/payments/selectors/payments.selector';
import { isConektaPaymentAction } from 'features/payments/utils/is-conekta-payment-action.util';
import { handleConektaPaymentAction } from 'features/payments/utils/handle-conekta-payment-action.util';

export const useConfirmConektaPaymentService = () => {
  const dispatch = useDispatch();
  const currentPaymentAction = useSelector(conektaPaymentActionSelector);

  return useMutation(requestConfirmBuyPasses, {
    onSuccess: response => {
      const hasPaymentAction =
        isConektaPaymentAction(response) && response.requiresAction;

      if (!hasPaymentAction) return;

      // Solo se re-despacha cuando Conekta devolvió una verificación DISTINTA. El
      // modal consulta el estado cada pocos segundos, y guardar la misma acción otra
      // vez cambiaría la URL del iframe por identidad, remontándolo y cortando el
      // reto que el usuario está contestando.
      if (response.redirectUrl === currentPaymentAction?.redirectUrl) return;

      dispatch(handleConektaPaymentAction(response));
    },
  });
};
